import React from 'react';
import { Dropdown, Menu } from 'antd';
import { CloseOutlined, DownOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { ActionBar, SelectionInfo, ButtonGroup } from '../styles';
import { DefaultStageMappingType } from '../../../api/integrations';
import useHirePortTheme from '../../../hooks/useHirePortTheme';
import Button from '../../../UI/buttons/Button';
import { STAGE_TYPES } from '../types/stageTypes';
import { getStageTypeColor } from '../utils/stageColors';

interface ActionToolbarProps {
    selectedCount: number;
    onApplyStageType: (stageType: DefaultStageMappingType | null, isUnmapped?: boolean) => void;
    onClearSelection: () => void;
}

const ActionToolbar: React.FC<ActionToolbarProps> = ({
    selectedCount,
    onApplyStageType,
    onClearSelection
}) => {
    const { t } = useTranslation();
    const theme = useHirePortTheme();

    // Create stage type menu
    const stageTypeMenu = (
        <Menu>
            {STAGE_TYPES.map(type => (
                <Menu.Item
                    key={type.value}
                    onClick={() => onApplyStageType(type.value)}
                >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div style={{
                            width: '8px',
                            height: '8px',
                            borderRadius: '50%',
                            backgroundColor: getStageTypeColor(type.value),
                            marginRight: '8px'
                        }} />
                        {type.label}
                    </div>
                </Menu.Item>
            ))}
            <Menu.Divider />
            <Menu.Item key="unmap" onClick={() => onApplyStageType(null, true)}>
                {t('ALWAYS_UNMAP_ACTION')}
            </Menu.Item>
            <Menu.Item key="remove-mapping" onClick={() => onApplyStageType(null, false)}>
                {t('REMOVE_MAPPING')}
            </Menu.Item>
        </Menu>
    );

    return (
        <ActionBar>
            <SelectionInfo>
                {selectedCount > 0
                    ? `${selectedCount} ${selectedCount === 1 ? t('ats.stage') : t('ats.stages')} ${t('ats.selected')}`
                    : t('SELECT_STAGES_TO_MAP')}
            </SelectionInfo>

            <ButtonGroup>
                <Dropdown
                    overlay={stageTypeMenu}
                    disabled={selectedCount === 0}
                    trigger={['click']}
                    overlayStyle={{ borderRadius: theme.radiusSmall }}
                >
                    <Button size="small" disabled={selectedCount === 0}>
                        {t('APPLY_TO_SELECTED')} <DownOutlined />
                    </Button>
                </Dropdown>

                <Button
                    onClick={onClearSelection}
                    disabled={selectedCount === 0}
                    size="small"
                    icon={<CloseOutlined />}
                >
                    {t('CLEAR_SELECTION')}
                </Button>
            </ButtonGroup>
        </ActionBar>
    );
};

export default ActionToolbar; 